import ProductSlider from "./product-slider";

export default ProductSlider;